export function loadGtag() {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-RR2QNXCLBE';
  script.async = true;
  document.head.appendChild(script);

  script.onload = () => {
    gtag('js', new Date());
    gtag('config', 'G-RR2QNXCLBE', {
      anonymize_ip: true
    });
  };
}
